import { render, staticRenderFns } from "./titleWidge.vue?vue&type=template&id=ba99827a&scoped=true"
import script from "./titleWidge.vue?vue&type=script&lang=js"
export * from "./titleWidge.vue?vue&type=script&lang=js"
import style0 from "./titleWidge.vue?vue&type=style&index=0&id=ba99827a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99827a",
  null
  
)

export default component.exports